import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { getExperienceTag } from 'services/mix-and-match';
import { GTM_PAGE_OTHER } from 'settings/gtm/gtmPageView';

export default function MixAndMatch(): JSX.Element {
  const { t } = useTranslation();

  useGtmPageView(GTM_PAGE_OTHER, '');

  return (
    <>
      <Helmet>
        <title>
          {t('META_TITLE_TEMPLATE', { title: t('MIX_AND_MATCH_META_TITLE') })}
        </title>
        <script type="text/javascript">{getExperienceTag('')}</script>
      </Helmet>
      <div id={'content'} />
    </>
  );
}
